import React, {Component} from 'react';
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import classes from './InfoLinksInput.module.css';

class InfoLinksInput extends Component  {
    state = {
        game_info_links: []
    };

    componentDidMount() {
        this.setState({game_info_links: this.props.infoLinks});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({game_info_links: this.props.infoLinks});
        }
    }

    addGameInfoLink = () => {
        this.setState(
            {game_info_links: [
                    ...this.state.game_info_links,
                    {
                        game_info_link_id: null,
                        game_info_link: "",
                        game_info_link_notes: "",
                        game_info_link_source: ""
                    }]
            });
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let infoLinksInputElement = null;

        if (this.state.game_info_links && this.state.game_info_links.length) {
            let info_links_index = 0;
            let game_info_links = [...this.state.game_info_links];
            infoLinksInputElement = (
                <>
                    <dd className="col-sm-9">
                        {game_info_links.map(info_link => {
                            let info_links_index_local = info_links_index;
                            const return_jsx = (
                                <div className={classes.infoLinksBlock} key={info_links_index_local}>
                                    <div className={classes.infoLinkField}>
                                        <Select
                                            options={[
                                                {value: 'Official Website', label: 'Official Website'},
                                                {value: 'Wikipedia', label: 'Wikipedia'},
                                                {value: 'BoardGameGeek', label: 'BoardGameGeek'},
                                                {value: 'Development Video', label: 'Development Video'},
                                                {value: 'Video Review', label: 'Video Review'},
                                                {value: 'Other Website', label: 'Other Website'}
                                            ]}
                                            defaultValue={{value: info_link.game_info_link_source, label: info_link.game_info_link_source}}
                                            onChange={(event) => {
                                                let game_info_links_local = [...game_info_links];
                                                game_info_links_local[info_links_index_local] = {
                                                    game_info_link_id: game_info_links_local[info_links_index_local].game_info_link_id,
                                                    game_info_link: game_info_links_local[info_links_index_local].game_info_link,
                                                    game_info_link_notes: game_info_links_local[info_links_index_local].game_info_link_notes,
                                                    game_info_link_source: event.value
                                                };
                                                this.setState({game_info_links: game_info_links_local});
                                                this.props.infoLinksUpdate(game_info_links_local);
                                            }}
                                            closeMenuOnSlelect={true}
                                        />
                                    </div>
                                    <div className={classes.deleteInfoLinks}>
                                        <Button className={classes.deleteInfoLinksButton} size="sm" variant={"outline-danger"} onClick={() => {
                                            let filtered_array = game_info_links.filter((value,index,array) => {
                                                return index !== (info_links_index_local)
                                            });

                                            this.setState({game_info_links: filtered_array});
                                            this.props.infoLinksUpdate(filtered_array);
                                        }}>X</Button>
                                    </div>
                                    <div className={classes.gameInfoLink}>
                                        <Form.Control
                                            as="textarea"
                                            rows="1"
                                            placeholder="Input the link here."
                                            value={info_link.game_info_link}
                                            onChange={(event) => {
                                                let game_info_links_local = [...game_info_links];
                                                game_info_links_local[info_links_index_local] = {
                                                    game_info_link_id: game_info_links_local[info_links_index_local].game_info_link_id,
                                                    game_info_link: event.target.value,
                                                    game_info_link_notes: game_info_links_local[info_links_index_local].game_info_link_notes,
                                                    game_info_link_source: game_info_links_local[info_links_index_local].game_info_link_source
                                                };
                                                this.setState({game_info_links: game_info_links_local});
                                                this.props.infoLinksUpdate(game_info_links_local);
                                            }}/>
                                    </div>
                                    <div className={classes.gameInfoLink}>
                                        <Form.Control
                                            as="textarea"
                                            rows="1"
                                            placeholder="Notes on the game source."
                                            value={info_link.game_info_link_notes}
                                            onChange={(event) => {
                                                let game_info_links_local = [...game_info_links];
                                                game_info_links_local[info_links_index_local] = {
                                                    game_info_link_id: game_info_links_local[info_links_index_local].game_info_link_id,
                                                    game_info_link: game_info_links_local[info_links_index_local].game_info_link,
                                                    game_info_link_notes: event.target.value,
                                                    game_info_link_source: game_info_links_local[info_links_index_local].game_info_link_source
                                                };
                                                this.setState({game_info_links: game_info_links_local});
                                                this.props.infoLinksUpdate(game_info_links_local);
                                            }}/>
                                    </div>
                                </div>
                            );
                            info_links_index++;

                            return return_jsx;
                        })}
                    </dd>
                    <dt className="col-sm-3"> </dt>
                </>
            );
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>More Information Links:</label></dt>
                {infoLinksInputElement}
                <dd className="col-sm-9"><Button className="col-sm-12" variant="outline-primary" onClick={this.addGameInfoLink}>Add Info Link</Button></dd>
            </dl>
        );
    }
}

export default InfoLinksInput;